import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49fa90e6")

_pushScopeId("data-v-49fa90e6")
const _hoisted_1 = { class: "rounded-xl border-gray-100 shadow-xl p-6" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-2/3" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-green-700" }, "Volumen en cancha por especie")
], -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-center my-4"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm text-center my-4"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "p-2" }, null, -1)
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "font-bold text-green-600" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_13 = { class: "font-bold text-green-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UITextSelect = _resolveComponent("UITextSelect")
  const _component_Pie = _resolveComponent("Pie")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_UITextSelect, {
          items: $setup.canchas,
          onSelected: _cache[1] || (_cache[1] = canchaId => $setup.requestStats(canchaId))
        }, null, 8, ["items"])
      ])
    ]),
    ($setup.isLoading)
      ? (_openBlock(), _createBlock("p", _hoisted_5, "...cargando stats"))
      : ($setup.selectedCancha && !$setup.hasStatsData)
        ? (_openBlock(), _createBlock("p", _hoisted_6, "Sin datos"))
        : ($setup.selectedCancha && $setup.hasStatsData)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_Pie, {
                "chart-data": $setup.chartData,
                height: 250,
                "chart-options": { locale: 'es-ES', plugins: { legend: {display: false} }, maintainAspectRatio: false }
              }, null, 8, ["chart-data"]),
              _hoisted_8,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.items, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.text+item.value
                }, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("p", _hoisted_10, _toDisplayString(item.text), 1),
                    _createVNode("p", null, _toDisplayString(item.value.toLocaleString('es-CL')), 1)
                  ])
                ]))
              }), 128)),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", null, [
                  _createVNode("p", _hoisted_13, _toDisplayString($setup.sum.toLocaleString('es-CL')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
})